/**
 * Extract browser name and version from user agent
 */
function getBrowserInfo(userAgent) {
    const browsers = [
        { name: 'Chrome', regex: /Chrome\/(\d+)/ },
        { name: 'Firefox', regex: /Firefox\/(\d+)/ },
        { name: 'Safari', regex: /Safari\/(\d+)/ },
        { name: 'Edge', regex: /Edg\/(\d+)/ },
        { name: 'Opera', regex: /OPR\/(\d+)/ },
    ];
    for (const browser of browsers) {
        const match = userAgent.match(browser.regex);
        if (match) {
            return `${browser.name} ${match[1]}`;
        }
    }
    return 'Unknown';
}
/**
 * Extract OS name from user agent
 */
function getOSInfo(userAgent) {
    const oses = [
        { name: 'Windows 11', regex: /Windows NT 10.0.*Win64/ },
        { name: 'Windows 10', regex: /Windows NT 10.0/ },
        { name: 'macOS', regex: /Macintosh.*Mac OS X (\d+[._]\d+)/ },
        { name: 'Linux', regex: /Linux/ },
        { name: 'iOS', regex: /iPhone|iPad|iPod/ },
        { name: 'Android', regex: /Android (\d+)/ },
    ];
    for (const os of oses) {
        const match = userAgent.match(os.regex);
        if (match) {
            if (os.name === 'macOS' && match[1]) {
                return `macOS ${match[1].replace('_', '.')}`;
            }
            if (os.name === 'Android' && match[1]) {
                return `Android ${match[1]}`;
            }
            return os.name;
        }
    }
    return 'Unknown';
}
/**
 * Capture current browser context for bug reporting
 *
 * @returns Browser context data
 */
export function captureBugReportContext() {
    const ua = navigator.userAgent;
    return {
        url: window.location.href,
        userAgent: ua,
        browser: getBrowserInfo(ua),
        os: getOSInfo(ua),
        screenSize: `${window.screen.width}x${window.screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        timestamp: new Date().toISOString(),
    };
}
/**
 * Capture screenshot of current page
 * Uses native browser API for simplicity
 *
 * @returns Promise<Blob | null> Screenshot blob or null if failed
 */
export async function captureScreenshot() {
    try {
        // Use modern browser screenshot API if available
        if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
            console.warn('Screenshot capture not supported in this browser');
            return null;
        }
        // For now, we'll let the user manually upload a screenshot
        // Automatic screenshot requires more complex implementation
        return null;
    }
    catch (error) {
        console.error('Failed to capture screenshot:', error);
        return null;
    }
}
